var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[(_vm.$route.meta.is_cached)?_c('keep-alive',[_c('router-view')],1):_vm._e(),(!_vm.$route.meta.is_cached)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }